import React from 'react'
import styled from 'styled-components'
import enveloppePlane from '../../../assets/enveloppe_plane.svg'
import { StyledBrandingButton } from '../MoveForm/MoveForm.style'

const StyledColdLeadValidationScreen = styled.div`
  display: flex;
  justify-content: space-around;
  height: 626px;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 0 12px 0 var(--black-20);
  background-color: #f5f7fa;
  flex-direction: column;
  padding: 3rem 2rem;
  font-size: 18px;
  h3 {
    font-weight: normal;
    font-size: 18px;
  }
  p {
    text-align: center;
  }
`
const ColdLeadValidationScreen = ({ isLogicImmo }) => {
  const content = (
    <>
      <StyledColdLeadValidationScreen>
        <br />
        <img style={{ width: '148px' }} src={enveloppePlane} alt="" />
        <div style={{ width: '100%' }}>
          <h3>
            Merci, <b> votre demande d&apos;estimation a bien été envoyée. </b> Un conseiller vous contactera.
          </h3>
          <p>Obtenez plus de détails sur le coût de votre déménagement. </p>
        </div>
        <StyledBrandingButton isLogicImmo={isLogicImmo} style={{ width: '100%' }} tag="a" size="lg" href="https://www.desbrasenplus.com/estimation-demenagement-1">
          Continuer
        </StyledBrandingButton>
        <br />
      </StyledColdLeadValidationScreen>
    </>
  )
  return content
}

export default ColdLeadValidationScreen
